<div class="plataformaFacturacion tab-pane fade show active">
    <div class="cabeceraTabla row">
        <div class="col-12 intro"><p translate>inv.platformList.intro</p></div>
        <div class="col-12 col-md-5 col-sm-6">
            <label for="buscadorPF" translate>inv.platformList.searchPF</label>
            <input type="text" id="buscadorPF" class="col-12" placeholder="{{'inv.platformList.searchPFpPaceholder' | translate}}" [(ngModel)]="platformFilter.name">
        </div>
        <div class="col btNuevaPlataforma align-bottom">
            <button type="button" class=" btn btn-primary pull-right" (click)="openAddPlatform()" translate><i class="fa fa-plus"></i> inv.platformList.buttonNewPF</button>
        </div>
    </div>
    <table class="table table-hover table-striped">
        <thead>
        <tr>
            <th scope="col">
                <span class="d-none d-md-block" translate>inv.platformList.headerPFFull</span>
                <span class="d-block d-md-none" translate>inv.platformList.headerPF</span>
            </th>
            <th scope="col" class="d-none d-lg-table-cell"><span translate>inv.platformList.headerDate</span></th>
            <th scope="col" class="text-right"><span translate>inv.platformList.headerAction</span></th>
        </tr>
        </thead>
        <tbody>
            <tr class="noResultFound" *ngIf="platforms.length === 0">
                <td colspan="3"><span translate>cli.adhesionList.noResultFound</span></td>
            </tr>
            <tr *ngFor="let pt of platforms | filterBy: platformFilter | paginate: { itemsPerPage: itemsPerPage, currentPage: p }; let i = index">
                <td><span class="truncateTD">{{ pt.name }}</span></td>
                <td class="d-none d-lg-table-cell">{{ pt.createdAt | date:'dd-MM-yyyy H:mm:ss' }}</td>
                <td class="text-right">
                    <button title="{{'inv.platformList.editPFtitle' | translate}}" (click)="openEditPlatform(pt, i)"><i class="fa fa-pencil"></i> <span class="d-none d-md-inline-block" translate>inv.platformList.editPFbt</span></button>
                    <button title="{{'inv.platformList.deletePFtitle' | translate}}" *ngIf="pt.numReceivers == 0" (click)="openDeletePlatform(pt, i)"><i class="fa fa-trash"></i> <span class="d-none d-md-inline-block" translate>inv.platformList.deletePFbt</span></button>
                    <button title="{{'inv.platformList.deletePFtitle' | translate}}" *ngIf="pt.numReceivers > 0" disabled=""><i class="fa fa-trash"></i> <span class="d-none d-md-inline-block" translate>inv.platformList.deletePFbt</span></button>
                </td>
            </tr>
        </tbody>
    </table>


    <div *ngIf="platforms.length > 0" class="paginador">
        <pagination-controls (pageChange)="p = $event" autoHide="true"
                             previousLabel="{{'inv.list.previous' | translate}}"
                             nextLabel="{{'inv.list.next' | translate}}" class="pull-right">
        </pagination-controls>

        <div class="controlPaginador pull-left">
            <label class="d-none d-sm-inline-block" translate>inv.list.platformPage</label>
            <select [(ngModel)]="itemsPerPage" class="custom-select">
                <option value="5" selected>5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="1000">1000</option>
            </select>
        </div>
    </div>
</div>


<!-- MODAL create platform -->
<ng-template #addPlatform let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate>inv.createPF.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="input-group row">
            <label class="col-5" translate>
                inv.createPF.name
            </label>
            <input [(ngModel)]="platform.name" type="text" class="col-7">
            <div *ngIf="errors && errors['name'].length > 0" class="notaPie col-7 ml-auto">
                <span *ngFor="let error of errors['name']">{{ error }}</span>
            </div>
        </div>
        <div class="input-group row">
            <label class="col-5" translate>
                inv.createPF.certificate
            </label>
            <div class="custom-file">
                <span class="custom-file-label truncate" for="inputGroupFile01" *ngIf="isFileLoaded">{{ platform.platformCerts[0].certificate.issuer }}<i class="fa fa-file-o"></i></span>
                <span class="custom-file-label truncate" for="inputGroupFile01" *ngIf="!isFileLoaded" translate>inv.createPF.selectFile<i class="fa fa-file-o"></i></span>
                <input [(ngModel)]="platform.platformCerts['certificate'['file']]" type="file" (change)="addFile($event)" class="custom-file-input" id="inputGroupFile01">
            </div>

            <div class="notaPie col-7 ml-auto">
                <div *ngIf="errors && errors.platformCert[0].certificate.file.length > 0">
                    <span *ngFor="let error of errors.platformCert[0].certificate.file">{{ error }}</span>
                </div>
                <div *ngIf="errors && errors.errors.length > 0">
                    <span *ngFor="let error of errors.errors">{{ error }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>inv.createPF.buttonCancel</button>
            <button type="button" [disabled]="(platform.name.length === 0 || !isFileLoaded)" class="btn btn-primary" (click)="savePlatform()" translate>inv.createPF.buttonCreate</button>
        </div>
    </div>
</ng-template>


<!-- MODAL remove platform -->
<ng-template #removePlatform let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate="">inv.platformList.deletePFTitle</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <span translate>inv.platformList.deletePFBody</span>
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>inv.platformList.deletePFBtCancel</button>
            <button type="button" class="btn btn-primary" (click)="c('remove')" translate>inv.platformList.deletePFBtOK</button>
        </div>
    </div>
</ng-template>


<!-- MODAL edit platform -->
<ng-template #editPlatform let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate>inv.editPF.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <!-- Mostrar datos edicion certificado -->
        <div class="input-group">
            <label class="col-4 col-sm-3 " translate>
                inv.createPF.name
            </label>
            <input [(ngModel)]="platform.name" type="text" class="col-8 col-sm-8" (change)="editPlatformName(platform)">
            <div *ngIf="errors && errors.name.length > 0" class="notaPie col-7 ml-auto">
                <span *ngFor="let error of errors.name">{{ error }}</span>
            </div>
        </div>

        <div class="input-group" *ngFor="let cert of platform.platformCerts; let i=index">
            <label class="col-4 col-sm-3" translate>
                inv.createPF.certificate
            </label>
            <div class="listado_certificados col-8 row">
                <label class="col-8" title="{{cert.certificate.issuer}} - {{cert.certificate.serial}}">{{cert.certificate.issuer}} - {{cert.certificate.serial}}</label>
                <div class="col">
                    <a (click)="onDeleteCertificateClicked(platform, i)" class="btn-icono col" title="{{'inv.createPF.deleteFile' | translate}}"><i class="fa fa-trash"></i></a>
                    <a *ngIf="(platform.platformCerts.length === i +1 && certificates.length === 0)" (click)="onAddCertificateClicked()" class="btn-icono col" title="{{'inv.createPF.addFile' | translate}}"><i class="fa fa-plus"></i></a>
                </div>
            </div>
        </div>

        <!-- Creacion dinámica de inputs para certificados -->
        <div *ngFor="let cert of certificates; let i=index" class="">
            <div *ngIf="(platform.platformCerts.length + i) < MAX_PLATFORMS" class="input-group">
                <label class="col-4 col-sm-3" translate>
                    inv.createPF.certificate
                </label>
                <div class="col-8 row">
                    <div class="custom-file col-8">
                        <span class="custom-file-label truncate" for="inputGroupFile01" translate>inv.createPF.selectFile<i class="fa fa-file-o"></i></span>
                        <input type="file" (change)="addOptionalFile($event, platform, certificates)" class="custom-file-input" id="inputGroupFile01">
                    </div>
                    <div class="col">
                        <a (click)="onRemoveCertificateClicked(i)" class="btn-icono" title="{{'inv.createPF.deleteFile' | translate}}Eliminar certificado"><i class="fa fa-trash"></i></a>
                    </div>
                </div>
                <!-- Mostrar los errores -->
                <div class="notaPie col-7 ml-auto">
                    <div *ngIf="errors && errors.platformCert[0].certificate.file.length > 0">
                        <span *ngFor="let error of errors.platformCert[0].certificate.file">{{ error }}</span>
                    </div>
                    <div *ngIf="errors && errors.errors.length > 0">
                        <span *ngFor="let error of errors.errors">{{ error }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-platform-list/inv-platform-list.component.html